import { type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

interface PageProps {
  children: ReactNode;
  className?: string;
  /** Subtract bottom dock height from scroll area */
  withDock?: boolean;
}

export function Page({ children, className, withDock = true }: PageProps) {
  return (
    <div
      className={cn(
        'flex flex-col flex-1 overflow-y-auto overflow-x-hidden liquid-scrollbar',
        'bg-[#eef5ec] bg-page-mesh',
        withDock && 'pb-24',
        className,
      )}
    >
      {children}
    </div>
  );
}
